import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

//Components
import Header from "./components/Header/header.js";
import NotFound from "./components/404 Page/NotFound.js";
import ScrollToTopButton from "./components/ScrollToTop/ScrollToTopButton.js";
import Footer from "./components/Footer/footer.js";

//Home Page
import Elephant from "./Page/Home/ElephantMainImage/elephant.js";
import Box from "./Page/Home/Box1/box.js";
import Box3Back from "./Page/Home/BackImage1/Box3back.js";
import Box3 from "./Page/Home/Box2/Box3.js";
import Box2Back2 from "./Page/Home/BackImage2/box2back.js";
import Box2 from "./Page/Home/Box3/box2";
import BackgroundImage from "./Page/Home/BackImage3/BackgroundImage";
import ImageSection from "./Page/Home/SnaitheVision/ImageSection";
import ThinkImage from "./Page/Home/BackImage4/ThinkImage";
import Businesses from "./Page/Home/SnaitheBusinesses/Businesses";
import AGirl1Image from "./Page/Home/BackImage5/AGirl1Image";
import SnaitheGrowth from "./Page/Home/SnaitheGrowth/SnaitheGrowth.js";
import VideoLoopComponent from "./Page/Home/BackImage6/AI1";
import SnaitheFuture from "./Page/Home/SnaitheFuture/SnaitheFuture.js";
import GirlWithHair from "./Page/Home/BackImage7/GirlWithHair";
import ManExitSnaitheImage from "./Page/Home/SnaitheJourney/ManExit-Snaithe.js";
import BidTypeBack from "./Page/Home/BackImage8/BidTypeBack";
import BidType from "./Page/Home/BidType/BidType";
import RentTypeBackground from "./Page/Home/BackImage9/RentTypeBack";
import RentType from "./Page/Home/RentType/RentType";
import CodeHideBack from "./Page/Home/BackImage10/CodeHideBack";
import CodeHide from "./Page/Home/CodeHide/CodeHide";
import HeveaGripBackground from "./Page/Home/BackImage11/HeveaGripBack";
import HeveaGrip from "./Page/Home/HeveaGrip/HeveaGrip";
import MCTypeBackground from "./Page/Home/BackImage12/MCTypeBack";
import MCType from "./Page/Home/MCType/MCType";
import MineThunder1 from "./Page/Home/MineThunder/MineThunder.js";
import GymFighters from "./Page/Home/GymFighters/GymFighters";
import SagwanWood from "./Page/Home/SagwanWood/SagwanWood";
import MianBuilder from "./Page/Home/MianBuilder/MianBuilder";
import StudioOwnAbout from "./Page/Home/StudioOwn/StudioOwnAbout";
import LogoSlideshow from "./Page/Home/LogoSlideshow/LogoSlideshow";

//Brands Page
import BrandsOfSnaithe from "./Page/Brands/BrandsOfSnaithe/BrandsOfSnaithe";
import BidTypeBrands1 from "./Page/Brands/BidTypeBrand/BidTypeBrands";
import RentTypeBrands from "./Page/Brands/RentTypeBrand/RentTypeBrands";
import SagwanWoodBrands from "./Page/Brands/SagwanWoodBrands/SagwanWoodBrands";
import MCTypeBrands from "./Page/Brands/MCTypeBrands/MCTypeBrands";
import GymFightersBrands from "./Page/Brands/GymFightersBrands/GymFightersBrands";
import MiningTypeBrands from "./Page/Brands/MineThunderBrands/MiningTypeBrands.js";
import HeveaGripBrands from "./Page/Brands/HeveaGripBrands/HeveaGripBrands.js";
import CodeHideBrands from "./Page/Brands/CodeHideBrands/CodeHideBrands.js";
import MianBuilderBrands from "./Page/Brands/MianBuilderBrands/MianBuilderBrands";
import StudioOwnBrands from "./Page/Brands/StudioOwnBrands/StudioOwnBrands";

//About Page
import About from "./Page/About/About/About.js";
import SnaitheAbout from "./Page/About/SnaitheAbout/SnaitheAbout";
import AboutTitle from "./Page/About/AboutTitle/AboutTitles.js";
import CodeHideAbout from "./Page/About/CodeHideAbout/CodeHideAbout";
import BidTypeAbout from "./Page/About/BidTypeAbout/BidTypeAbout";
import RentTypeAbout from "./Page/About/RentTypeAbout/RentTypeAbout";
import MiningTypeAbout from "./Page/About/MineThunderAbout/MiningTypeAbout";
import HeveaGripAbout from "./Page/About/HeveaGripAbout/HeveaGripAbout";
import MCTypeAbout from "./Page/About/MCTypeAbout/MCTypeAbout";
import SagwanWoodAbout from "./Page/About/SagwanWoodAbout/SagwanWoodAbout";
import GymFightersAbout from "./Page/About/GymFightersAbout/GymFightersAbout.js";
import MianBuilderAbout from "./Page/About/MianBuilderAbout/MianBuilderAbout";

//History Page
import HistoryVideo1Auto from "./Page/History/HistoryVideo/HistoryVideo1Auto";
import SnaitheHistoryStart from "./Page/History/SnaitheHistoryStart/HistoryStart";
import HistoryImageSnaithe from "./Page/History/FullHistory/HistoryImage-1.js";

//Contact Page
import ReceptionSnaithe from "./Page/Contact/SnaitheReception/ReceptionSnaithe.js";
import ContactUs from "./Page/Contact/ContactForm/ContactUs.js";
import ContactReceptionImage from "./Page/Contact/ContactImage1/ContactImage1";
import VideoPlayerOfContact1 from "./Page/Contact/VideoContact/VideoContact1";
import ContactInfo from "./Page/Contact/ContactInfo/ContactInfo";
import TakTillGolvBrands from "./Page/Brands/TakTillGolvBrands/TakTillGolvBrands.js";
import TakTillGolvAbout from "./Page/Home/TakTillGolv/TakTillGolvAbout.js";

function App() {
  return (
    <Router basename="/">
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/history" element={<HistoryPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/brands" element={<BrandsPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </Router>
  );
}

function Home() {
  return (
    <>
      <Header />
      <Elephant />
      <Box />
      <Box3Back />
      <Box3 />
      <Box2Back2 />
      <Box2 />
      <BackgroundImage />
      <ImageSection />
      <ThinkImage />
      <Businesses />
      <AGirl1Image />
      <SnaitheGrowth />
      <VideoLoopComponent />
      <SnaitheFuture />
      <GirlWithHair />
      <ManExitSnaitheImage />
      <BidTypeBack />
      <BidType />
      <RentTypeBackground />
      <RentType />
      <CodeHideBack />
      <CodeHide />
      <HeveaGripBackground />
      <HeveaGrip />
      <MCTypeBackground />
      <MCType />
      <MineThunder1 />
      <GymFighters />
      <SagwanWood />
      <MianBuilder />
      <TakTillGolvAbout />

      <StudioOwnAbout />
      <LogoSlideshow />
      <ScrollToTopButton />
      <Footer />
    </>
  );
}

function BrandsPage() {
  return (
    <>
      <Header />
      <BrandsOfSnaithe />
      <BidTypeBrands1 />
      <RentTypeBrands />
      <SagwanWoodBrands />
      <MCTypeBrands />
      <GymFightersBrands />
      <MiningTypeBrands />
      <HeveaGripBrands />
      <CodeHideBrands />
      <MianBuilderBrands />
      <TakTillGolvBrands />
      <StudioOwnBrands />
      <ScrollToTopButton />
      <Footer />
    </>
  );
}

function AboutPage() {
  return (
    <>
      <Header />
      <About />
      <SnaitheAbout />
      <AboutTitle />
      <CodeHideAbout />
      <BidTypeAbout />
      <RentTypeAbout />
      <MiningTypeAbout />
      <HeveaGripAbout />
      <MCTypeAbout />
      <SagwanWoodAbout />
      <GymFightersAbout />
      <StudioOwnAbout />
      <MianBuilderAbout />
<TakTillGolvAbout />
      <ScrollToTopButton />
      <Footer />
    </>
  );
}

function HistoryPage() {
  return (
    <>
      <Header />
      <HistoryVideo1Auto />
      <SnaitheHistoryStart />
      <HistoryImageSnaithe />
      <Footer />
    </>
  );
}

function NotFoundPage() {
  return (
    <>
      <Header />
      <NotFound />
      <Footer />
    </>
  );
}

function ContactPage() {
  return (
    <>
      <Header />
      <ReceptionSnaithe />
      <ContactUs />
      <ContactReceptionImage />
      <VideoPlayerOfContact1 />
       <ScrollToTopButton />
      <Footer />
    </>
  );
}

export default App;
